import { LoginForm } from './LoginModels';
import { instanceApi } from '../../services';

export const login = (data: LoginForm): Promise<any> => instanceApi.post('auth/Authenticate/Login', data);
export const getUserLoginData = (): Promise<any> => instanceApi.get('api/user/getuserlogindata');

export const getTranslationsByBrokerId = (brokerId?: string): Promise<any> => instanceApi.get(`api/settings/gettranslationsbybroker?brokerId=${brokerId}`);

export const loginRepresentative = (data: LoginForm): Promise<any> => instanceApi.post('auth/Authenticate/Login', data);

// export const getAvailablePromotions = (): Promise<any> => instanceApi.get('api/promotion/available');
